import React from "react";

import DateTimeService from "../../../../utils/dateTimeService";

import EmploymentFormContainer from "./components/EmploymentFormContainer";
import EmploymentDetailFormTitle from "./components/EmploymentDetailFormTitle";
import EmployeeDetailItemsContainer from "./components/EmployeeDetailItemsContainer";
import EmployeeDetailItemContainer from "./components/EmployeeDetailItemContainer";
import TheDatePicker from "./components/TheDatePicker";
import TheInput from "./components/TheInput";
import TheSelectDropDown from "./components/TheSelectDropDown";
import TheButton from "./components/TheButton";
import ButtonsContainer from "./components/ButtonsContainer";
import TheImageInput from "./components/TheImageInput";
import TheAttachment from "./components/TheAttachment";
import RegionField from "./RegionField";

const EmploymentDetailForm = (props) => {
  const {
    disableTransactionTypeField,
    main_url,
    user_id,
    handleAddFormInputChange,
    handleDatePickerChange,
    selectedEmployeeId,
    exitStatusList,
    selected_exit_status,
    disConStatusList,
    selected_disCon_status,
    handleSelectedDisConStatus,
    jobList,
    selected_job,
    handleSelectedJob,
    handleSelectedExitStatus,
    handleSelectedEmployeeId,
    employeeIdList,
    handleLevelSelectorChange,
    career_level,
    career_sub_level,
    level_options,
    sub_level_options,
    submitAddForm,
    handleUpdateData,
    handleGoBack,
    edit,
    employeeName,
    statusList,
    handleFormCancel,
    resignReason,
    transactionTypesList,
    transactionType,
    handleSelectedTransactionType,
    handleSelectedBranch,
    disconDate,
    handleSelectedDeaprtment,
    effectiveDate,
    branchlist,
    selected_branch,
    departmentlist,
    handleSelectedDesignation,
    designationList,
    selected_designation,
    actualDate,
    selected_status,
    handleSelectedStatus,
    employedDate,
    salaryPermission,
    salaryList,
    handleChangeFile,
    removeOldDocument,
    attachment,
    remark,
    demotionReasonsList,
    demotionReason,
    handleSelectedDemotionReason,
    monitoringEndDate,
    lastWorkingDate,
    hasDoneSubmitOrSave,
  } = props;

  // These numbers in arrays corresponds to the ids in tbl_employment_details_transaction_type
  // The keys are the input field names in employment details form
  const disableInputsStrategy = {
    employee_code: [],
    employee_name: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    employee_status: [1, 2, 5, 6, 7, 8, 9, 10, 11, 12],
    designation: [1, 2, 3, 11],
    branch: [3, 5, 11],
    career_level: [1, 2, 3, 11],
    career_sub_level: [1, 2, 3, 11],
    date: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    remark: [],
    attachment: [],
    employed_date: [1, 2, 5, 6, 7, 8, 9, 10, 11],
    effective_date: [],
    actual_date: [],
    job_title: [1, 2, 3, 11],
    demotion_reason: [1, 2, 3, 4, 5, 6, 9, 10, 11, 12],
    monitoring_end_date: [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12],
    last_working_date: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
    discontinuous_status: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
    discontinuous_date: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    exit_status: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    resign_reason: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  };

  const disableInput = (inputName) => {
    if (!transactionType) return true;
    if (
      transactionType &&
      !selectedEmployeeId &&
      inputName !== "employee_code"
    ) {
      return true;
    }
    return disableInputsStrategy[inputName].includes(transactionType.value);
  };

  // Department
  let department;
  if (selected_designation != null) {
    department = departmentlist.find(
      (v) => v.departments_id === selected_designation.departments_id,
    );
  }

  const filteredJobList = selected_designation
    ? jobList.filter(
        (job) =>
          job.designation_id == selected_designation.value &&
          job.department_id == selected_designation.departments_id,
      )
    : [];

  // EmployeeName
  let name = employeeName ?? "";

  // Salary
  let salaryInputFieldValue = 0;
  if (career_sub_level) {
    const salaryInfo = salaryList.find(
      (v) => v.career_sub_level === career_sub_level.career_sub_level_id,
    );
    if (salaryInfo) {
      salaryInputFieldValue = salaryInfo.basic_salary;
    }
  }

  const canViewSalary =
    salaryPermission.length > 0 ||
    (career_sub_level ? career_sub_level.career_level_id : null) <= 6;

  // Career Sub Level
  const careerSubLevelOptions = career_level
    ? sub_level_options.filter(
        (c) => c.career_level_id === career_level.career_level_id * 1,
      )
    : sub_level_options;

  return (
    <form>
      <EmploymentFormContainer>
        <EmploymentDetailFormTitle />
        <EmployeeDetailItemsContainer>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {/* ___________________________________________________________ */}
            {/* ----- Transaction Type ----- */}
            <EmployeeDetailItemContainer label="Transaction Type">
              <TheSelectDropDown
                options={transactionTypesList}
                value={transactionType}
                onChange={handleSelectedTransactionType}
                isDisabled={disableTransactionTypeField}
              />
            </EmployeeDetailItemContainer>
            {/* ___________________________________________________________ */}
            {/* ----- Employee Code ----- */}
            <EmployeeDetailItemContainer label="Employee Code">
              {edit ? (
                <TheInput value={selectedEmployeeId} isDisabled={true} />
              ) : (
                <TheSelectDropDown
                  options={employeeIdList}
                  value={selectedEmployeeId}
                  onChange={handleSelectedEmployeeId}
                  isDisabled={edit ? true : disableInput("employee_code")}
                />
              )}
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Employee Name ----- */}
            <EmployeeDetailItemContainer label="Employee Name">
              <TheInput
                value={name.toUpperCase()}
                isDisabled={!!edit || disableInput("employee_name")}
                placeholder=""
                isRequired={true}
                name="name"
                onChange={handleAddFormInputChange}
                style={{ width: "100%", height: 40 }}
              />
            </EmployeeDetailItemContainer>
            {/* ___________________________________________________________ */}
            {/* ----- Employee Status ----- */}
            <EmployeeDetailItemContainer label="Employee Status">
              <TheSelectDropDown
                options={statusList}
                value={selected_status}
                onChange={handleSelectedStatus}
                isDisabled={disableInput("employee_status")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Designation ----- */}
            <EmployeeDetailItemContainer label="Designation">
              <TheSelectDropDown
                options={designationList}
                value={selected_designation}
                onChange={handleSelectedDesignation}
                isDisabled={disableInput("designation")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Job Role ----- */}
            <EmployeeDetailItemContainer label="Job Role">
              <TheSelectDropDown
                options={filteredJobList}
                value={selected_job}
                onChange={handleSelectedJob}
                isDisabled={disableInput("job_title")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Department ----- */}
            <EmployeeDetailItemContainer label="Department">
              <TheSelectDropDown
                options={departmentlist}
                value={department}
                onChange={handleSelectedDeaprtment}
                isDisabled={true}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Branch ----- */}
            <EmployeeDetailItemContainer label="Branch">
              <TheSelectDropDown
                options={branchlist}
                value={selected_branch}
                onChange={handleSelectedBranch}
                isDisabled={disableInput("branch")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Region ----- */}
            <RegionField
              key={selected_branch?.value}
              branchId={selected_branch?.value}
            />

            {/* ___________________________________________________________ */}
            {/* ----- Career Level ----- */}
            <EmployeeDetailItemContainer label="Career Level">
              <TheSelectDropDown
                options={level_options}
                value={career_level}
                onChange={(val) =>
                  handleLevelSelectorChange(val, "career_level")
                }
                isDisabled={disableInput("career_level")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Career Sub Level ----- */}
            <EmployeeDetailItemContainer label="Career Sub Level">
              <TheSelectDropDown
                options={careerSubLevelOptions}
                value={career_sub_level}
                onChange={(val) =>
                  handleLevelSelectorChange(val, "career_sub_level")
                }
                isDisabled={disableInput("career_sub_level")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Date ----- */}
            <EmployeeDetailItemContainer label="Date">
              <TheInput
                value={new DateTimeService().todayDate}
                placeholder=""
                isRequired={true}
                name="date"
                onChange={null}
                style={{ width: "100%", height: 40 }}
                isDisabled={disableInput("date")}
              />
            </EmployeeDetailItemContainer>

            {/* This canViewSalary check is for layout, not for logic! */}
            {canViewSalary && (
              <EmployeeDetailItemContainer label="Attachment (Limit: 1MB)">
                {typeof attachment === "string" ? (
                  <TheAttachment
                    main_url={main_url}
                    user_id={user_id}
                    doc={attachment}
                    removeOldDocument={removeOldDocument}
                  />
                ) : (
                  <TheImageInput
                    checkFiles={handleChangeFile}
                    isDisabled={disableInput("attachment")}
                  />
                )}
              </EmployeeDetailItemContainer>
            )}
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {/* ___________________________________________________________ */}
            {/* ----- Employed Date ----- */}
            <EmployeeDetailItemContainer label="Employed Date">
              <TheDatePicker
                value={new DateTimeService(employedDate).formatDate}
                name="employedDate"
                onChange={handleDatePickerChange}
                isDisabled={disableInput("employed_date")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Effective Date ----- */}
            <EmployeeDetailItemContainer label="Effective Date">
              <TheDatePicker
                value={new DateTimeService(effectiveDate).formatDate}
                name="effectiveDate"
                onChange={handleDatePickerChange}
                isDisabled={disableInput("effective_date")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Arrival Date ----- */}
            <EmployeeDetailItemContainer label="Arrival Date">
              <TheDatePicker
                value={new DateTimeService(actualDate).formatDate}
                name="actualDate"
                onChange={handleDatePickerChange}
                isDisabled={disableInput("actual_date")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Salary ----- */}
            {canViewSalary && (
              <EmployeeDetailItemContainer label="Salary">
                <TheInput
                  type="number"
                  value={salaryInputFieldValue}
                  isDisabled={true}
                  isRequired={true}
                  name="salary"
                  onChange={handleAddFormInputChange}
                />
              </EmployeeDetailItemContainer>
            )}
            {/* ___________________________________________________________ */}
            {/* ----- Reason of Demotion ----- */}
            <EmployeeDetailItemContainer label="Reason of Demotion">
              <TheSelectDropDown
                options={demotionReasonsList}
                value={demotionReason}
                onChange={handleSelectedDemotionReason}
                isDisabled={disableInput("demotion_reason")}
              />
            </EmployeeDetailItemContainer>
            {/* ___________________________________________________________ */}
            {/* ----- End of Monitoring Date ----- */}
            <EmployeeDetailItemContainer label="End of Monitoring Date">
              <TheDatePicker
                value={new DateTimeService(monitoringEndDate).formatDate}
                name="monitoringEndDate"
                onChange={handleDatePickerChange}
                isDisabled={disableInput("monitoring_end_date")}
              />
            </EmployeeDetailItemContainer>
            {/* ___________________________________________________________ */}
            {/* ----- Last Working Date ----- */}
            <EmployeeDetailItemContainer label="Last Working Date">
              <TheDatePicker
                value={new DateTimeService(lastWorkingDate).formatDate}
                name="lastWorkingDate"
                onChange={handleDatePickerChange}
                isDisabled={disableInput("last_working_date")}
              />
            </EmployeeDetailItemContainer>
            {/* ___________________________________________________________ */}
            {/* ----- Discontinuous Status ----- */}
            <EmployeeDetailItemContainer label="Discontinuous Status">
              <TheSelectDropDown
                options={disConStatusList}
                value={selected_disCon_status}
                onChange={handleSelectedDisConStatus}
                isDisabled={disableInput("discontinuous_status")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Discontinuous Date ----- */}
            <EmployeeDetailItemContainer label="Discontinuous Date">
              <TheDatePicker
                value={new DateTimeService(disconDate).formatDate}
                name="disconDate"
                onChange={handleDatePickerChange}
                isDisabled={disableInput("discontinuous_date")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Exit Status ----- */}
            <EmployeeDetailItemContainer label="Exit Status">
              <TheSelectDropDown
                options={exitStatusList}
                value={selected_exit_status}
                onChange={handleSelectedExitStatus}
                isDisabled={disableInput("exit_status")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Resign Reason ----- */}
            <EmployeeDetailItemContainer label="Resign Reason">
              <TheInput
                value={resignReason}
                placeholder=""
                name="resignReason"
                onChange={handleAddFormInputChange}
                style={{ width: "100%", height: 40 }}
                isDisabled={disableInput("resign_reason")}
              />
            </EmployeeDetailItemContainer>

            {/* ___________________________________________________________ */}
            {/* ----- Remark ----- */}
            <EmployeeDetailItemContainer label="Remark">
              <TheInput
                value={remark}
                placeholder=""
                name="remark"
                onChange={handleAddFormInputChange}
                style={{ width: "100%", height: 40 }}
                isDisabled={disableInput("remark")}
              />
            </EmployeeDetailItemContainer>

            {/* This canViewSalary check is for layout, not for logic! */}
            {!canViewSalary && (
              <EmployeeDetailItemContainer label="Attachment (Limit: 1MB)">
                {typeof attachment === "string" ? (
                  <TheAttachment
                    main_url={main_url}
                    user_id={user_id}
                    doc={attachment}
                    removeOldDocument={removeOldDocument}
                  />
                ) : (
                  <TheImageInput
                    checkFiles={handleChangeFile}
                    isDisabled={disableInput("attachment")}
                  />
                )}
              </EmployeeDetailItemContainer>
            )}
          </div>
        </EmployeeDetailItemsContainer>

        {/* ___________________________________________________________ */}
        {/* ----- Buttons ----- */}
        {hasDoneSubmitOrSave ? (
          <ButtonsContainer>
            <TheButton onClick={handleGoBack} label="Go Back" />
          </ButtonsContainer>
        ) : edit ? (
          <ButtonsContainer>
            <TheButton onClick={handleUpdateData} label="Save" />
            <TheButton
              onClick={handleFormCancel}
              label="Cancel"
              style={{ background: "red" }}
            />
          </ButtonsContainer>
        ) : (
          <ButtonsContainer>
            <TheButton onClick={submitAddForm} label="Submit" />
            <TheButton
              onClick={handleFormCancel}
              label="Cancel"
              style={{ background: "red" }}
            />
          </ButtonsContainer>
        )}
      </EmploymentFormContainer>
    </form>
  );
};

export default EmploymentDetailForm;
